export default __webpack_public_path__ + "static/media/footer-shape-mobile.da1bb202.png";